import AffectedCasesBarChart from './AffectedCasesBarChart';
import AffectedCasesTable from './AffectedCasesTable';
import ExploreCasesPies from './ExploreCasesPies';
import ExploreCasesTable from './ExploreCasesTable';
import GenesBarChart from './GenesBarChart';
import GenesTable from './GenesTable';
import GeneLolliplot from './Lolliplot/GeneLolliplot.fixture';
import SsmLolliplot from './Lolliplot/SsmLolliplot.fixture';
import ProjectBreakdown from './ProjectBreakdown';
import SsmsBarChart from './SsmsBarChart';
import SsmsTable from './SsmsTable';

export {
  AffectedCasesBarChart,
  AffectedCasesTable,
  ExploreCasesPies,
  ExploreCasesTable,
  GenesBarChart,
  GenesTable,
  GeneLolliplot,
  SsmLolliplot,
  ProjectBreakdown,
  SsmsBarChart,
  SsmsTable,
};



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/index.js